import { render, staticRenderFns } from "./blogIndex.vue?vue&type=template&id=45ee1ece"
import script from "./blogIndex.vue?vue&type=script&lang=js"
export * from "./blogIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports